import React, { useCallback, useEffect, useState } from 'react';
import styles from './ForWhomSection.module.css';
import { CustomCardInfo, CustomFooter, CustomImage, CustomLoader, CustomMoreSection, CustomTextMarkdown, CustomTitle } from '../../../components';
import { getForWhomContent } from '../../../services/contentService';
import { useNavigate, useParams } from 'react-router-dom';

const ForWhomSection = () => {

    const { sectionId } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [pageContent, setPageContent] = useState<any>(true);

    const handleGetForWhomContent = useCallback(async () => {
        try {
            setIsLoading(true);

            const content = await getForWhomContent();

            if (content.sections.length < Number(sectionId) + 1) {
                navigate('/for_whom');
                return;
            }

            setPageContent(content.sections[Number(sectionId)]);

            const homeImg = new Image();
            homeImg.onload = () => setIsLoading(false);
            homeImg.src = `${process.env.REACT_APP_API_BASE_URL}${content.sections[Number(sectionId)].image?.url}`;
        } catch(e) {
            console.error(e);
            throw e;
        }
    }, [navigate, sectionId]);

    useEffect(() => {
        handleGetForWhomContent();
    }, [sectionId, handleGetForWhomContent]);

    return (
        <div className={styles.container}>
            
            { !isLoading &&
                <>
                    
                    {/* A block */}
                    <div className={styles.A_block}>
                        <div className={styles.A_block_icon_container}>
                            <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.Section_presentation_card.icon?.url}`} alt="" />
                        </div>
                        <CustomTitle center>{pageContent.Section_presentation_card.title}</CustomTitle>
                        <CustomTextMarkdown components={{ p : 'h3' }} className={styles.A_block_subtitle}>{pageContent.Section_presentation_card.subtitle}</CustomTextMarkdown>
                    </div>


                    {/* B block */}
                    <div className={styles.B_block}>
                        <div>
                            <CustomTextMarkdown className={styles.B_block_paragraph}>{pageContent.A_paragraph}</CustomTextMarkdown>
                        </div>

                        <div className={styles.B_block_image_container}>
                            <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.image?.url}`} alt="" />
                        </div>
                    </div>


                    {/* C block */}
                    <div className={styles.C_block}>
                        <div className={styles.C_block_content}>
                            <CustomTitle isSubtitle className={styles.C_block_subtitle}>{pageContent.subtitle}</CustomTitle>
                            <CustomTextMarkdown components={{ p : 'h3' }} className={styles.C_block_title}>{pageContent.title}</CustomTextMarkdown>
                            <CustomTextMarkdown className={styles.C_block_paragraph}>{pageContent.B_paragraph}</CustomTextMarkdown>
                        </div>

                        <div className={styles.C_block_cards_container}>
                            { pageContent.Block_cards.map((item: any, index: number) => {
                                return (
                                    <CustomCardInfo 
                                        key={index}
                                        title={item.title}
                                        content={item.content}
                                        className={styles.C_block_card}
                                        iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.icon?.url}`}
                                    />
                                );
                            })}
                        </div>
                    </div>

                    <CustomMoreSection isForWhomPage />
                    <CustomFooter />
                
                </>
            }

            { isLoading &&
                <div className={styles.container_loader}>
                    <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
                </div>
            }
        </div>
    );
}

export default ForWhomSection;